<template>
  <div>

    <div class="pxkeji-right-box">

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="action" slot-scope="info">
          <pxkeji-btn name="学习明细" size="small" @click="showInfo(info.courseId,info.userId)" type="primary" />
        </span>
      </a-table>
    </div>

   <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="60%"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" :uid="addedit.uid" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./studyInfo.vue"; //学习明细

const columns = [

  {
    dataIndex: "courseName",
    key: "courseName",
    align: "center",
    title: "课程名称"
  },
  {
    dataIndex: "courseType",
    key: "courseType",
    align: "center",
    title: "课程分类"
  },
  {
    dataIndex: "hourCount",
    key: "hourCount",
    align: "center",
    title: "课时数"
  },
  {
        dataIndex: "teacherName",
        key: "teacherName",
        align: "center",
        title: "讲师"
    },
  {
    dataIndex: "learnHourCount",
    key: "learnHourCount",
    align: "center",
    title: "已学课时"
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  props: {
    id: 0,
    uid: 0,
    dataZone:''
  },
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      addedit: {
        //编辑
        visible: false,
        id: 0,
        title: "",
        uid: 0
      },
      visible: false //弹框
    };
  },
  components: {
    Info: Info,
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.recordStatistics
        .getPageList(
          null,
          null,
          null,
          null,
          null,
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          null,
          null,
          null,
          null,
          null,
          this.uid,
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    //查看学习详情
    showInfo(id,uid) {
      this.addedit.visible = true;
      this.addedit.id = id;
      this.addedit.uid = uid;
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
       /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {}
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.user
        .prohibit(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.operation.coupon
            .removeById(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    /**发券 */
    giveCoupon(id) {
      this.issuing.visible = true;
      this.issuing.id = id;
    },
    /**明细 */
    voidCoupon(id) {
      this.voids.visible = true;
      this.voids.id = id;
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

